import { listLawftIds } from 'services/Settings';
import { mapLawftIdsToOptions } from 'utils/lawftIdListHelpers';

/**
 * Fetches one page of Lawft IDs for async-paginated dropdowns.
 */
export const fetchLawftIdPage = async ({
  page = 1,
  pageSize = 10,
  status = 'ACTIVE',
  filters = {},
  practice_area = '',
  search = '',
  sort_order = 'alphabet_ascending',
  excludeLawftIds = [],
} = {}) => {
  const requestFilters = {
    ...filters,
    ...(search ? { keyword: search } : {}),
  };

  const response = await listLawftIds(pageSize, page, '', status, requestFilters, sort_order, practice_area, true);
  const meta = response?.data || {};
  const excludeSet = new Set(excludeLawftIds);

  const options = mapLawftIdsToOptions(meta.lawft_id || []).filter((opt) => !excludeSet.has(opt.value));

  return {
    options,
    hasMore: meta.has_next ?? false,
    additional: { page: page + 1 },
  };
};

/**
 * loadOptions adapter for react-select-async-paginate.
 */
export const loadLawftIdOptions = async (_search, _loadedOptions, additional, config = {}) => {
  const {
    pageSize = 10,
    status = 'ACTIVE',
    filters = {},
    practice_area = '',
    sort_order = 'alphabet_ascending',
    excludeLawftIds = [],
  } = config;

  const page = additional?.page ?? 1;

  try {
    return await fetchLawftIdPage({
      page,
      pageSize,
      status,
      filters,
      practice_area,
      search: _search,
      sort_order,
      excludeLawftIds,
    });
  } catch (error) {
    console.error('Error loading Lawft ID options:', error);
    return { options: [], hasMore: false, additional: { page: 1 } };
  }
};

/**
 * Resolves stored Lawft ID values to dropdown option objects for edit mode.
 */
export const resolveLawftIdOptions = (ids = [], knownOptions = []) => {
  if (!Array.isArray(ids)) return [];

  return ids.map((id) => {
    const match = knownOptions.find((opt) => opt.value === id);
    if (match) {
      return {
        label: match.label || match.lawft_id_name,
        value: match.value || match.lawft_id,
      };
    }
    return { label: id, value: id };
  });
};
